<template>
    <div
        class="l-modal-backdrop"
        @click="
            () => {
                if (closeOnBackdropClick) close();
            }
        "
        @keyup.esc="
            () => {
                if (closeOnBackdropClick) close();
            }
        "
    >
        <div
            :class="['l-modal', size]"
            role="dialog"
            aria-labelledby="modalTitle"
            aria-describedby="modalDescription"
            @click.stop="() => {}"
            @keyup.enter.stop="() => {}"
        >
            <header id="modalTitle" class="l-modal-header">
                <button
                    v-show="showCloseBtnHeader"
                    type="button"
                    class="close color-dark close-btn"
                    aria-label="Close modal"
                    data-test-id="modal-close-btn"
                    @click="close"
                >
                    <span v-show="closeButtonText" class="close-text r-default-margin-s">{{
                        closeButtonText
                    }}</span>
                    <span class="close-icon">
                        <i class="fal fa-times"></i>
                    </span>
                </button>
                <h3
                    ref="modal-title"
                    v-b-popover.hover.leftbottom="{
                        content: title,
                        disabled: !isTitleOverflowing,
                    }"
                    class="modal-title color-dark ellipsis"
                >
                    <slot name="header">
                        Modal
                    </slot>
                </h3>
            </header>

            <section id="modalDescription" class="l-modal-body">
                <slot name="body"></slot>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        closeOnBackdropClick: {
            type: Boolean,
            default: true,
        },
        showCloseBtnHeader: {
            type: Boolean,
            default: true,
        },
        closeButtonText: {
            type: String,
            default: "",
        },
        size: {
            type: String,
            default: "m",
            validator: value => ["s", "m", "l", "xl"].includes(value),
        },
    },
    data() {
        return {
            title: "",
            isTitleOverflowing: false,
        };
    },
    created() {
        // Allow closing the modal by pressing the key `esc`
        //
        this.closeOnEscape = e => {
            if (e.keyCode === 27) {
                this.close();
            }
        };
        window.addEventListener("keydown", this.closeOnEscape);
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.closeOnEscape);
    },
    updated() {
        // When title is overflowing, add popover with full text
        // and display it
        //
        if (this.$slots.header) {
            this.title = this.$slots.header[0].text;
            this.isTitleOverflowing =
                this.$refs["modal-title"].clientWidth < this.$refs["modal-title"].scrollWidth;
        }
    },
    methods: {
        close() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
.l-modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    color: #424242;
    background-color: rgba(0, 0, 0, 0.3);
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1050;
}
.l-modal {
    margin: 30px auto;
    border-radius: 6px;
    position: relative;
    background-color: #fff;
    background-clip: padding-box;
    outline: 0;
    border-bottom: solid 3px #f5f5f5;
    box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);
    z-index: 1051;
}
.l-modal.s {
    width: 400px;
}
.l-modal.m {
    width: 600px;
}
.l-modal.l {
    width: 800px;
}
.l-modal.xl {
    width: 900px;
}

.l-modal-header {
    border-bottom: none;
    border-radius: 6px 6px 0 0;
    padding: 0;
    background: linear-gradient(135deg, rgba(247, 245, 254, 1) 0%, rgba(251, 240, 237, 1) 100%);
    color: #fff;
}
.l-modal-header .modal-title {
    padding: 1.4rem 2.4rem;
}
.l-modal-header .close {
    float: right;
    font-weight: 700;
    line-height: 1;
    text-shadow: 0 1px 0 #fff;
    -webkit-appearance: none;
    cursor: pointer;
    background: 0 0;
    border: 0;
    margin: 1.4rem 2.4rem 0 0;
    padding: 0.5rem;
    font-size: 14px;
    opacity: 0.8;
}
.l-modal-header .close-text {
    font-size: 20px;
}

.l-modal-body {
    position: relative;
    padding: 2.4rem;

    /*  As all modals will most likely have buttons at the bottom of their bodies, 
     *  we need to remove the `.btn` marging from the padding to have a consistent
     *  space between the edge of the modal and its content.  
     */
    padding-bottom: calc(2.4rem - 10px);
}

.l-modal >>> .footer {
    display: flex;
    justify-content: flex-end;
}
.l-modal >>> .footer .btn {
    margin-left: 8px;
}

/* Responsive */
@media (max-width: 800px) {
    .l-modal.l {
        width: 90vw;
    }
}
@media (max-width: 600px) {
    .l-modal.m {
        width: 90vw;
    }
}
@media (max-width: 400px) {
    .l-modal.s {
        width: 90vw;
    }
}
</style>
